import { Navigate, Outlet } from 'react-router-dom';
import { useProductsContext } from '../../context/ProductsContext';

// Guards the consolidated Inventory section. Admits anyone who can see at least
// one of its tabs: ops/admin/finance (section view) or sales managers (forecast
// only). The dashboard itself hides tabs the user can't see.
export default function InventoryRoute() {
  const { permissions, permissionsLoaded } = useProductsContext();

  // Wait for /api/me before judging. Permissions start as {}, so deciding on
  // the first render bounced every direct link and page reload under this
  // guard (/inventory, Nano Forecast, Nano Planning) to the dashboard, even
  // for users who could see the page.
  if (!permissionsLoaded) return null;

  if (
    !permissions.canViewInventory &&
    !permissions.canAccessForecasts &&
    !permissions.canAccessAdmin
  ) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
